<span
  *ngIf="!isLk"
  class="np-informer-trigger"
  (click)="openModal()"
  pTooltip="Поддержка"
  tooltipPosition="left"
  tooltipStyleClass="p-n-tooltip"
  [showDelay]="200"
  [life]="1000">
  <i class="pi pi-wrench cursor-pointer p-text-secondary"></i>
</span>

<i
  *ngIf="isLk"
  class="pi pi-wrench cursor-pointer p-text-secondary hover:frm-color-blue lk-eu-header__utility-icon"
  (click)="openModal()"
  pTooltip="Поддержка"
  tooltipPosition="bottom"
  [showDelay]="200">
</i>

<p-dialog
  header="Заявка в поддержку ФРМ"
  styleClass="xl:w-4 md:w-7 w-11 frm-filters-ui-v2"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [(visible)]="isShowModal"
  (onHide)="closeModal()">
  <p-messages
    severity="info"
    styleClass="mb-3">
    <ng-template pTemplate="">
      <div class="flex gap-2 align-items-center">
        <i
          class="pi pi-exclamation-circle"
          style="font-size: 1.3rem"></i>
        <p>
          После отправки запроса ответ и все последующие сообщения Вы получите на почту "{{
            authService.currentProfile?.email || '-'
          }}"
        </p>
      </div>
    </ng-template>
  </p-messages>

  <ng-container *ngIf="!loading; else loadingTemplate">
    <div class="p-fluid">
      <div class="field">
        <label class="font-medium required-field">Описание</label>
        <crm-editor
          [(value)]="form.description"
          height="110px"></crm-editor>
      </div>
    </div>

    <div class="flex justify-content-between align-items-center mt-5">
      <crm-button
        icon="pi pi-check"
        label="Отправить"
        styleClass="p-button-success"
        [disabled]="!form.description?.length"
        (onClick)="save()"></crm-button>

      <crm-button
        *ngIf="isAccess()"
        icon="pi pi-external-link"
        styleClass="p-button-text"
        label="Посмотреть все заявки"
        (onClick)="redirectToLk()"></crm-button>
    </div>
  </ng-container>

  <ng-template #loadingTemplate>
    <crm-spinner></crm-spinner>
  </ng-template>
</p-dialog>
